"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _uiwidgetsCommon = require("uiwidgets-common");

var _format = require("./format");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (value, format, opts) {
    // if not passed something to format, abort early.
    if (!value) {
        return null;
    }

    // format is optional, if the callee has passed opts as the second parameter, we must rejig them.
    if (format && !(0, _uiwidgetsCommon.isString)(format)) {
        opts = format;
        format = _format.DEFAULT_DATE_FORMAT;
    }

    format || (format = _format.DEFAULT_DATE_FORMAT);
    opts || (opts = {});

    // if the value is a straight Date object, short circuit the rest of the function and just format it.
    if ((0, _uiwidgetsCommon.isDate)(value) || _moment2.default.isMoment(value)) {
        var date = opts.utc ? _moment2.default.utc(value) : (0, _moment2.default)(value);
        return date.format(format);
    }

    // if the value is an object with a `type` of "date".
    if (value.type === "date") {
        var _date = opts.utc ? _moment2.default.utc(value.start) : (0, _moment2.default)(value.start);
        return _date.format(format);
    }

    return null;
};
//# sourceMappingURL=DateFormat.js.map